import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. From web apps to desktop apps. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All Projects</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All Projects</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project, index) => (
  <ProjectCard
    key={index}
    project={project}
    openModal={openModal}
    setOpenModal={setOpenModal}
  />
))
}
          {projects
            .filter((item) => item.category === toggle)
            .map((project, index) => (
            <ProjectCard
            key={index}
            project={project}
            openModal={openModal}
            setOpenModal={setOpenModal}
            />
))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects